import { Injectable, ElementRef } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ColumnDefinition } from '../models/colDef.model';
import { httpConnect } from './httpConnect.service';
@Injectable()
export class ConfiguradorColumnas{
    
    constructor(private _connSvc : httpConnect){

    }
    /**
     * 
     * @param id_usuario Usuario
     * @param id_permiso ID de la pantalla
     * @param arrOriginal Array que contiene todas las columnas de la consulta
     * @returns Array con las columnas que se deberán mostrar en el listado
     */
    public GetColumnasVista(id_usuario : number, id_permiso : number, arrOriginal : Array<ColumnDefinition>) : Promise<Array<ColumnDefinition>>{
        let _arrOriginal = [...arrOriginal];
        return new Promise((resolve, reject) => {
            this._getColumnas(id_usuario, id_permiso)
            .subscribe(res => {
                let arrColumnas : Array<ColumnDefinition> = new Array<ColumnDefinition>();
                let _alias = res.filter(c=> c.visible).map(c => ({alias : c.alias, orden : c.orden})).sort((a, b) => a.orden - b.orden);
                _alias.forEach(c => {
                    let _columna = _arrOriginal.find(o => o.columnDef == c.alias);
                    if(_columna != null){
                        _columna.visible = true;
                        arrColumnas.push(_columna)
                    }
                })
                resolve(arrColumnas);
            }, error => reject(error.error.message))
        })
        
    }

    private _getColumnas(id_usuario : number, id_permiso : number) : Observable<any>{
        let params = {
            IdUsuario : id_usuario,
            IdPermiso : id_permiso
        }
        return this._connSvc.postAPI('General', 'ListConfiguradorVistasColumnas', params)
        .pipe(
            map(res => res.success ? res.response : throwError(res.message), catchError(error => throwError(error)))
        )
    }
}